import React, { useEffect, useState } from 'react';
import { IActionContext } from '@msdyn365-commerce/core';
import { IDimensionForSelectedVariant, ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { ProductsDataActions, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import getAllDimensionsForProductActionDataAction, {
    GetAllDimensionsForProductInput
} from '../../../actions/get-all-dimensions-for-product';
import { getProductVariantUrl } from '../../../common/getProductVariantUrl';

const ShopUsed = ({
    product,
    resources,
    context
}: {
    product?: SimpleProduct;
    context: IActionContext;
    resources: {
        shopUsedText: string;
    };
}) => {
    const [usedProductUrl, setUsedProductUrl] = useState('');
    const [recId, itemId] = React.useMemo(() => {
        const values = product?.ExtensionProperties?.find(ep => ep.Key === 'UsedSku')?.Value?.StringValue?.split(':');

        return values && values.length === 2 ? [+values[0], values[1]] : [0, null];
    }, [product]);

    useEffect(() => {
        setUsedProductUrl('');
        if (!recId) {
            return;
        }

        const input = new GetAllDimensionsForProductInput(recId, context.requestContext.apiSettings.channelId);
        void getAllDimensionsForProductActionDataAction(input, context)
            .then((dimensions: IDimensionForSelectedVariant[]) => {
                const validProducts: Record<number, Record<number, string>> = {};

                dimensions.forEach(d => {
                    d.dimensionValuesWithInventory?.forEach(inv => {
                        inv.ProductIds?.forEach(variantId => {
                            const variantDims = validProducts[variantId] ?? (validProducts[variantId] = {});
                            variantDims[d.DimensionTypeValue] = inv.DimensionValue?.Value ?? '';
                        });
                    });
                });

                var variantId = ArrayExtensions.firstOrDefault(
                    Object.keys(validProducts).filter(variantId => Object.keys(validProducts[variantId]).length === dimensions.length)
                );

                return variantId ? +variantId : 0;
            })
            .then(variantId => {
                if (variantId) {
                    void ProductsDataActions.getByIdAsync(
                        { callerContext: context },
                        +variantId,
                        context.requestContext.apiSettings.channelId
                    ).then(productDetails => {
                        const usedProductUrl = getProductVariantUrl(productDetails, context);
                        setUsedProductUrl(usedProductUrl);
                    });
                }
            });
    }, [context, recId]);

    if (!usedProductUrl) {
        return null;
    }

    return (
        <div className='hei-buybox-shop-used'>
            <a href={usedProductUrl} data-used-sku={`${recId}:${itemId}`}>
                <span>{resources.shopUsedText ?? 'Shop available used'}</span>
            </a>
        </div>
    );
};

export { ShopUsed };
